import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface FacebookIconProps extends SvgIconProps {}

export const FacebookIcon = ({
  style,
  ...iconProps
}: FacebookIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon
      style={style}
      {...iconProps}
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
    >
      <path
        d="M13.5 27C20.9558 27 27 20.9558 27 13.5C27 6.04416 20.9558 0 13.5 0C6.04416 0 0 6.04416 0 13.5C0 20.9558 6.04416 27 13.5 27Z"
        fill="white"
      />
      <path
        d="M17.89 4.14453H14.8994C13.1247 4.14453 11.1508 4.89095 11.1508 7.46347C11.1594 8.35983 11.1508 9.21829 11.1508 10.1844H9.09766V13.4515H11.2143V22.8569H15.1037V13.3894H17.6709L17.9031 10.1752H15.0367C15.0367 10.1752 15.0431 8.74544 15.0367 8.33022C15.0367 7.31362 16.0945 7.37183 16.1581 7.37183C16.6615 7.37183 17.6402 7.3733 17.8915 7.37183V4.14453H17.89Z"
        fill="#23305F"
      />
    </SvgIcon>
  );
};
